import {ITTIModelBase} from "@/ittijs/ITTIModel";

export default class extends ITTIModelBase {
	constructor() {
		super('MontajiSpravki');
	}
}